module.exports = __webpack_public_path__ + "img/chocada.7723e838.png";